export default {
    state: {
        termsElementId: ''
    },
    setTermsElement (id) {
        this.state.termsElementId = id
    }
}


// WEBPACK FOOTER //
// ./src/store/LinkStore.js